import {
  defineComponent,
  getCurrentInstance,
  reactive,
  watch
} from '@vue/composition-api'
import RichUtil from '@/pages/Survey/components/RichUtil/index.vue'
import './index.scss'
import _ from 'lodash'
import { getTopicOptions, changeOptionValue } from '../../util'
import { SCORE_NUM_TYPE, SCORE_TYPE } from '../../config'
import i18n from '@/locales'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
import BarScore from '@/pages/Survey/components/BarScore'
import StarScore from '@/pages/Survey/components/StarScore'
import FaceScore from '@/pages/Survey/components/FaceScore'
import { Message } from '@gcommon/gcommon-ui'
import CommonTetxEdit from '@/components/CommonTetxEdit'
import moment from 'moment'

const MatrixNpsEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })
    const instance = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return instance?.proxy.$t(initParam) as string
    }
    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )

    const changeOptionsRewrite = (value, options, isChild = 0) => {
      changeOptionValue(value, options, isChild)
    }

    const addMatrixSubtopics = (index) => {
      const subtopics = {
        bizId: '',
        customizeOption: 0,
        customizeOptionValue: null,
        id: '',
        matrixTopics: null,
        maxScore: 10,
        orderNum: 1,
        parentId: '',
        topicName: '',
        topicSetting: null,
        topicType: 18,
        key: new Date().getTime()
      }
      state.editItem.matrixTopics.splice(index + 1, 0, subtopics)
    }

    const deleteMatrixSubtopics = (index) => {
      if (state.editItem.matrixTopics.length < 3) {
        Message({
          message: tran('survy.matrixTips'),
          type: 'warning'
        })
      } else {
        state.editItem.matrixTopics.splice(index, 1)
      }
    }

    const getTrueValue = (matrixTopicsItem) => {
      let value: any
      props.item.matrixValue?.forEach((item) => {
        if (item.subTopicId === matrixTopicsItem.bizId) {
          value = item.value
        }
      })
      return value
    }

    const updateValue = (value, index) => {
      state.editItem.matrixValue[index].value = value
      state.editItem.isShowTitleError = false
      emit('answer', state.editItem)
    }

    return () => {
      //子题列表
      // const matrixTopicStr = getTopicOptions(
      //   state.editItem.matrixTopics,
      //   'topicName'
      // )
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item topic-edit-content-title">
            {/* <div class="topic-edit-content-item-title">{tran('survy.matrixNpsquestionName')}:</div>
            <RichUtil
              onchangeValue={(value) => (state.editItem.topicName = value)}
              placeholder={tran('survy.plctopicname')}
              value={state.editItem.topicName}></RichUtil> */}
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder={tran('survy.matrixNpsquestionName')}
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <div class="topic-edit-content-item">
            {/* <div class="topic-edit-content-item-title">
              {tran('survy.matrixNpsremark')}:
            </div>
            <RichUtil
              onchangeValue={(value) => {
                state.editItem.topicSetting.topicRemark = value
              }}
              placeholder={tran('survy.plcremark')}
              value={state.editItem.topicSetting.topicRemark}></RichUtil> */}
            {/* <el-input
              type="textarea"
              class='rich-input'
              autosize={true}
              resize="none"
              size='small'
              placeholder="请输入题目备注"
              value={state.editItem.topicSetting.topicRemark}
              onInput={(value) =>
                (state.editItem.topicSetting.topicRemark = value)
              }></el-input> */}
            <CommonTetxEdit
              needDynamicEvent
              initialData={state.editItem.topicSetting.topicRemark}
              placeholder={tran('survy.plcremark')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.topicRemark = value
              }}
            />
          </div>
          <div class="matrix-nps-topic-content-right">
            <div class="matrix-nps-topic-content-right-item-title">
              <span>{state.editItem.topicSetting.minScoreDesc}</span>
              <span style={{ flex: 1 }}></span>
              <span>{state.editItem.topicSetting.maxScoreDesc}</span>
              {
                /* 根据后端条件判断要不要渲染 */
                !!state.editItem?.topicSetting.customizeOption && (
                  <div class="cust-title">
                    {state.editItem?.topicSetting.customizeOptionValue}
                  </div>
                )
              }
              {/* <div style={{width:'100px',textAlign:'center'}}>不确定</div> */}
            </div>
            {state.editItem.matrixTopics.map((sitem, index) => {
              return (
                <div class="matrix-nps-topic-content-right-item" key={`${sitem.bizId?sitem.bizId:sitem.key}`}>
                  {/* <div
                    tabindex="-1"
                    class="sub-title"
                    domPropsInnerHTML={sitem.topicName}></div> */}
                  {/* <el-input
                    class="sub-title rich-input"
                    type="textarea"
                    autosize={true}
                    resize="none"
                    size="small"
                    placeholder="请输入子题名称"
                    value={sitem.topicName}
                    onInput={(value, index) => {
                      sitem.topicName = value
                      state.editItem.matrixTopics = props.item.matrixTopics
                    }}></el-input> */}
                  <div class="sub-title">
                    <CommonTetxEdit
                      needDynamicEvent
                      initialData={sitem.topicName}
                      placeholder={tran('survy.entersonName')}
                      handleUpdate={(value, index) => {
                        sitem.topicName = value
                        // state.editItem.matrixTopics = props.item.matrixTopics
                      }}
                    />
                  </div>
                  <div class="operate-icon">
                    <i
                      class="el-icon-circle-plus-outline el-icon-common-class"
                      onClick={() => {
                        addMatrixSubtopics(index)
                      }}></i>
                    <i
                      class="el-icon-delete el-icon-common-class"
                      onClick={() => {
                        deleteMatrixSubtopics(index)
                      }}></i>
                  </div>
                  {!state.editItem.topicSetting.scoreStyle && (
                    <div class="sub-score">
                      <BarScore
                        value={getTrueValue(sitem)}
                        minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                        maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                        onupdateValue={(value) => updateValue(value, index)}
                        isNps={true}
                        maxScore={11}
                        showTitle={false}
                        topicSetting={state.editItem.topicSetting}></BarScore>
                    </div>
                  )}
                  {state.editItem.topicSetting.scoreStyle === 1 && (
                    <div class="sub-score">
                      <StarScore
                        value={getTrueValue(sitem)}
                        minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                        maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                        onupdateValue={(value) => updateValue(value, index)}
                        maxScore={11}
                        isNps={true}
                        showTitle={false}
                        topicSetting={state.editItem.topicSetting}></StarScore>
                    </div>
                  )}
                  {state.editItem.topicSetting.scoreStyle === 2 && (
                    <div class="sub-score">
                      <FaceScore
                        value={getTrueValue(sitem)}
                        minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                        maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                        onupdateValue={(value) => updateValue(value, index)}
                        maxScore={11}
                        isNps={true}
                        showTitle={false}
                        topicSetting={state.editItem.topicSetting}></FaceScore>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
          {/* <div class="topic-edit-content-item nps-edit-input"> */}
          {/* <el-row>
              <el-col span={8}>
                <el-checkbox
                  value={state.editItem.topicSetting.isAllowNull}
                  onInput={(value) =>
                    (state.editItem.topicSetting.isAllowNull = value)
                  }>
                  {tran('survy.noneedans')}
                </el-checkbox>
              </el-col> */}
          {/* <el-col span={8}> */}
          {/* 自定义选项配置 key未知，等后端，暂用 customeOption */}
          {/* <el-checkbox
                  label="1"
                  key="customizeOption"
                  value={
                    state.editItem.topicSetting.customizeOption ? true : false
                  }
                  onInput={(value) => {
                    if (value) {
                      value = 1
                      if (!state.editItem.topicSetting.customizeOptionValue) {
                        state.editItem.topicSetting.customizeOptionValue = `${tran(
                          'survy.uncertain'
                        )}`
                      }
                    } else {
                      value = 0
                    }
                    state.editItem.topicSetting.customizeOption = value
                  }}>
                  {tran('survy.customeOption')}
                </el-checkbox>
                <el-input
                  size="small"
                  value={state.editItem.topicSetting.customizeOptionValue}
                  onInput={(value) => {
                    value = value.replace(/[0-9]/g, '')
                    state.editItem.topicSetting.customizeOptionValue = value
                  }}
                  onfocus={() => {
                    if (!state.editItem.topicSetting.customizeOption) {
                      state.editItem.topicSetting.customizeOption = 1
                    }
                  }}
                  placeholder={tran('survy.plccontent')}
                  style={{ marginLeft: '12px' }}
                  maxlength={i18n.locale === 'en' ? '9' : '4'}
                  // show-word-limit
                ></el-input>
              </el-col> */}
          {/* </el-row> */}
          {/* </div> */}
          {/* <div class="topic-edit-content-item nps-edit-input">
            <el-row>
              <el-col span={8}>
                <div>
                  <span class="topic-edit-content-item-label">
                    {tran('survy.lowdes')}{' '}
                  </span>
                  <el-input
                    size="small"
                    value={state.editItem.topicSetting.minScoreDesc}
                    onInput={(value) =>
                      (state.editItem.topicSetting.minScoreDesc = value)
                    }
                    placeholder={tran('survy.plccontent')}></el-input>
                </div>
              </el-col>

              <el-col span={8}>
                <div>
                  <span class="topic-edit-content-item-label">
                    {tran('survy.highdes')}{' '}
                  </span>
                  <el-input
                    size="small"
                    value={state.editItem.topicSetting.maxScoreDesc}
                    onInput={(value) =>
                      (state.editItem.topicSetting.maxScoreDesc = value)
                    }
                    placeholder={tran('survy.plccontent')}></el-input>
                </div>
              </el-col>
              <el-col span={8}>
                <div>
                  <span class="topic-edit-content-item-label">
                    {tran('survy.style')}{' '}
                  </span>
                  <el-select
                    size="small"
                    onInput={(value) =>
                      (state.editItem.topicSetting.scoreStyle = value)
                    }
                    value={state.editItem.topicSetting.scoreStyle}
                    placeholder={tran('survy.plcselect')}>
                    {SCORE_TYPE.map((sitem) => {
                      return (
                        <el-option
                          key={sitem.value}
                          label={sitem.label}
                          value={sitem.value}></el-option>
                      )
                    })}
                  </el-select>
                </div>
              </el-col>
            </el-row>
          </div> */}
          <div class="topic-edit-content-item">
            {/* <div class="topic-edit-content-item-title">
              {tran('survy.matrixNpselend')}:
            </div>
            <RichUtil
              needDynamicEvent={false}
              onchangeValue={(value) =>
                (state.editItem.topicSetting.endword = value)
              }
              placeholder={tran('survy.plcearlymsg')}
              value={state.editItem.topicSetting.endword}></RichUtil> */}
            {/* <el-input
              type="textarea"
              class="rich-input"
              autosize={true}
              resize="none"
              size="small"
              placeholder="矩阵NPS题提前结束语"
              value={state.editItem.topicSetting.endword}
              onInput={(value) =>
                (state.editItem.topicSetting.endword = value)
              }></el-input> */}
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder={tran('survy.matrixNpselend')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings
              type={props.item.topicType}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              minScoreDesc={state.editItem.topicSetting.minScoreDesc}
              maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
              scoreStyle={state.editItem.topicSetting.scoreStyle}
              customizeOption={
                state.editItem.topicSetting.customizeOption ? true : false
              }
              customizeOptionValue={
                state.editItem.topicSetting.customizeOptionValue
              }
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
              onChangeMinScoreDesc={(value) => {
                state.editItem.topicSetting.minScoreDesc = value
              }}
              onChangeMaxScoreDesc={(value) => {
                state.editItem.topicSetting.maxScoreDesc = value
              }}
              onChangeScoreStyle={(value) => {
                state.editItem.topicSetting.scoreStyle = value
              }}
              onChangeCustomizeOption={(value) => {
                state.editItem.topicSetting.customizeOption = value
              }}
              onChangeCustomizeOptionValue={(value) => {
                state.editItem.topicSetting.customizeOptionValue = value
              }}
            />
          </Portal>
        </div>
      )
    }
  }
})
export default MatrixNpsEdit
